export default "/images/vendor/flag-icon-css/flags/4x3/bt.svg?ef80804e14eb159e3936b7a92a477d0f";